// extracted by mini-css-extract-plugin
module.exports = {"Process":"Process_Process__b8vRf"};